"use client"

import Image from "next/image"
import Link from "next/link"
import {IUser} from "@/app/models/wp";
import AppIcon from "@/app/components/atomic/AppIcon";

const EndingPageReviewer = ({reviewer}: { reviewer: IUser }) => {
    const authorImg = `/assets/avatars/editors/${reviewer.authorPageImg}.png`
    const userName = `${reviewer.firstName} ${reviewer.lastName}`

    return (
        <div>
            <Link href={reviewer.authorPageUrl} className="flex">
                <div className="w-[45px] h-[45px] rounded-full bg-rm-blue flex items-center justify-center shrink-0">
                    <AppIcon
                        iconClassName="fa-magnifying-glass"
                        type="solid"
                        size="lg"
                        className="text-white"
                    />
                </div>

                <div className="flex gap-3 pr-5 rounded-full bg-rm-blue">
                    <div className="relative flex items-center">
                        <div className="relative w-[45px] h-[45px] rounded-2xl overflow-hidden shrink-0">
                            <Image
                                src={authorImg}
                                alt={userName}
                                fill
                                sizes="40px"
                                className="object-cover"
                                onError={(e) => {
                                    (e.target as HTMLImageElement).style.display = "none"
                                }}
                            />
                        </div>
                    </div>

                    <div className="flex flex-col leading-tight text-white">
                        <span className="font-bold text-rm-14">{userName}</span>
                        <span className="text-rm-12">{reviewer.jobTitle ?? "Expert"}</span>
                    </div>
                </div>
            </Link>

            <div className="bg-white flex flex-col shadow rounded-2xl p-5 text-pale text-rm-16 m-0">
                {reviewer.verifiedInfoText}
            </div>
        </div>
    )
}

export default EndingPageReviewer
